import { initReactI18next as p, useTranslation as w } from "react-i18next";
import h from "i18next-resources-to-backend";
import o from "i18next";
import { useMemo as l } from "react";
import { subscribeWithSelector as S } from "zustand/middleware";
import { shallow as b } from "zustand/shallow";
import { create as y } from "zustand";
const I = new Proxy({}, { get(t, e) {
  return "https://cdn.utsubo.io/i18n/0-0-122" + (e.startsWith("/") ? e : "/" + e);
} }), s = "en", v = [s, "ja", "fr"], u = "common";
function L(t = s, e = u) {
  return { supportedLngs: v, fallbackLng: s, lng: t, fallbackNS: u, defaultNS: u, ns: e };
}
async function m(t, e, n) {
  try {
    return await (await fetch(t, e)).json();
  } catch {
    if (n > 0)
      return console.error("Attempt failed. Retrying..."), await new Promise((r) => setTimeout(r, 1e3)), m(t, e, n - 1);
    throw new Error("Failed to fetch data after several attempts.");
  }
}
async function c(t = "common", e = {}) {
  o.isInitialized || o.use(p).use(h(async (n, a) => {
    const r = `/locales/${n}/${a}.json`, d = process.env.NODE_ENV === "development" ? r : I[r];
    return await m(d, { cache: "no-store", mode: "cors" }, 3);
  })).init(L(e.lng, t));
}
function j(t = "common", e = {}) {
  return l(async () => {
    await c(t, e);
  }, [t, e]), w(t, e);
}
const i = /* @__PURE__ */ y(S((t, e) => ({ i18next: o, lang: s, workspaceLang: "ja" })));
i.subscribe((t) => t.workspaceLang, async (t, e) => (t && t !== o.resolvedLanguage && (await c("common", { lng: t }), await o.changeLanguage(t)), true));
const g = (t, e) => i(t, e || b);
Object.assign(g, i);
const { getState: T, setState: f } = i, x = (t, e) => (l(async () => {
  if (typeof window > "u")
    return;
  let n = t;
  if (!e) {
    const a = /* @__PURE__ */ window.localStorage.getItem("lang");
    a ? n = a : n = navigator.language === "ja" ? "ja" : "en", document?.documentElement?.setAttribute("lang", n);
  }
  await c("common", { lng: n }), n && n !== o.resolvedLanguage && await o.changeLanguage(n), f({ lang: n });
}, [t, e]), null);
export {
  T as getStoreI18n,
  c as initI18n,
  f as setStoreI18n,
  x as useLanguageProvider,
  g as useStoreI18n,
  j as useTranslation
};
